import { BaseQuery } from './BaseQuery';
import { IExecutionOptions } from '../models/query';

export class CommentaryQuery extends BaseQuery {
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		return this.getRawValueForContentElement(executionOptions, 'commentary');
	}
}